export default "__VITE_ASSET__BEFL7c4h__"